<template>
  <div>
    <div class="drawDownAppText">
      <img src="../../assets/login.png" alt style="margin-top:80px" />
      <div style="margin-top: 30px;">{{biaoTi}}</div>
      <div class="xz">
        <div style="color: #fff; font-size: 25px;cursor: pointer;" @click="download">点击下载</div>
      </div>
      <div id="weixin-tip" v-show="weixinFlag"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      biaoTi: localStorage.getItem('biaoti'),
      weixinFlag: false,
    };
  },
  created() {
    this.is_weixin();
    // this.download()
  },
  methods: {
    is_weixin() {
      var ua = navigator.userAgent.toLowerCase();
      // console.log(/micromessenger/i.test(ua))
      if (/micromessenger/i.test(ua) == false) {
        this.weixinFlag = false;
      } else {
        this.weixinFlag = true;
      }
    },
    download() {
      let a = document.createElement('a');
      // a.setAttribute('download', 'yunxueyuan');
      a.setAttribute('target', '_blank');
      a.setAttribute('href', '/uploadfile/yunxueyuan.apk');
      // console.log(a)
      a.click();
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}

img {
  max-width: 100%;
  height: auto;
}

.drawDownAppText {
  height: 100vh;
  max-width: 100vw;
  font-size: 32px;
  text-align: center;

  padding-top: 20%;
  /* background-image: url(xz.png); */
  background-size: 100% 100%;
  background: linear-gradient(#fff, #4aaae2);
}

.drawDownAppText a {
  text-decoration: none;
}

.xz {
  padding: 1px 15px;
  background: #36f;
  width: 150px;
  border-radius: 35px;
  text-align: center;
  margin-left: 15%;
  box-shadow: 4px 4px 15px -3px #666;
  color: #fff;
  margin: 0 auto;
  margin-top: 100px;
  height: 45px;
}
#weixin-tip {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(78, 78, 78, 0.8);
  background-image: url('../../assets/appstroePic.jpg');
  filter: alpha(opacity=80);
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  z-index: 100;
}
#weixin-tip p {
  text-align: center;
  margin-top: 5%;
  padding: 0 5%;
}
</style>